/* GASSISA
=========================================================================================
* Descripcion: Hooks para identificar el tipo de dispositivo de la interfaz.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Deteccion de dispositivos portatiles sin romper el hook movil existente
* ---------------------------------------------------------------------------------------
*/

import { useState, useEffect } from 'react';

const getDeviceProfile = () => {
    if (typeof window === "undefined") {
        return { isMobile: false, isPortable: false };
    }

    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    const width = window.innerWidth || 0;
    const height = window.innerHeight || 0;
    const shortSide = Math.min(width, height);
    const longSide = Math.max(width, height);
    const isSmallScreen = width < 768;
    const isCompactLaptop = width <= 1024 && height <= 900;
    const isTabletOrHybrid = shortSide <= 900 && longSide <= 1366 && (navigator.maxTouchPoints || 0) > 0;

    return {
        isMobile: isMobileDevice || isSmallScreen,
        isPortable: isMobileDevice || isSmallScreen || isCompactLaptop || isTabletOrHybrid,
    };
};

export const useDeviceType = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkDevice = () => {
            setIsMobile(getDeviceProfile().isMobile);
        };

        checkDevice();
        window.addEventListener('resize', checkDevice);
        
        return () => window.removeEventListener('resize', checkDevice);
    }, []);

    return isMobile;
};

export const usePortableDevice = () => {
    const [isPortable, setIsPortable] = useState(false);

    useEffect(() => {
        const checkDevice = () => {
            setIsPortable(getDeviceProfile().isPortable);
        };

        checkDevice();
        window.addEventListener('resize', checkDevice);

        return () => window.removeEventListener('resize', checkDevice);
    }, []);

    return isPortable;
};

export default useDeviceType;